import React from "react";
import { FormDocumentBlock } from "./FormDocumentBlock";

export function FormDocumentRenderer({
  blocks = [],
  values = {},
  onChange,
  readOnly = false,
  mode = "fill",
}) {
  const handleValueChange = (blockId, nextValue) => {
    if (readOnly || !onChange) return;
    onChange({ ...values, [blockId]: nextValue });
  };

  return (
    <div className="space-y-1">
      {blocks.map((block) => (
        <FormDocumentBlock
          key={block.id}
          block={block}
          mode={mode}
          value={values[block.id]}
          readOnly={readOnly}
          onValueChange={(next) => handleValueChange(block.id, next)}
        />
      ))}
    </div>
  );
}
